import * as React from 'react';

import { sections } from 'components/lexemes';

import { SectionContentLinkListIdNine } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { FormattedText, P1 } from 'components/typography';

const setTitleElement = (id: SectionContentLinkListIdNine) => {
  const mapTitleAnchorToSectionId: {
    [key in SectionContentLinkListIdNine]: {
      id: SectionContentLinkListIdNine;
      title: string;
    };
  } = {
    [SectionContentLinkListIdNine.California]: {
      id: SectionContentLinkListIdNine.California,
      title: sections.tabNineSection.tab.list[0](),
    },

    [SectionContentLinkListIdNine.Colorado]: {
      id: SectionContentLinkListIdNine.Colorado,
      title: sections.tabNineSection.tab.list[1](),
    },

    [SectionContentLinkListIdNine.Connecticut]: {
      id: SectionContentLinkListIdNine.Connecticut,
      title: sections.tabNineSection.tab.list[2](),
    },
    [SectionContentLinkListIdNine.NewJersey]: {
      id: SectionContentLinkListIdNine.NewJersey,
      title: sections.tabNineSection.tab.list[3](),
    },
    [SectionContentLinkListIdNine.Oregon]: {
      id: SectionContentLinkListIdNine.Oregon,
      title: sections.tabNineSection.tab.list[4](),
    },
    [SectionContentLinkListIdNine.Texas]: {
      id: SectionContentLinkListIdNine.Texas,
      title: sections.tabNineSection.tab.list[5](),
    },
    [SectionContentLinkListIdNine.Utah]: {
      id: SectionContentLinkListIdNine.Utah,
      title: sections.tabNineSection.tab.list[6](),
    },
    [SectionContentLinkListIdNine.Virginia]: {
      id: SectionContentLinkListIdNine.Virginia,
      title: sections.tabNineSection.tab.list[7](),
    },
  };
  return <TitleAnchor {...mapTitleAnchorToSectionId[id]} />;
};

export const getPropsSectionNineContainer = () => {
  return {
    sections: {
      one: {
        title: sections.tabNineSection.section1.title(),
        text: (
          <FormattedText>
            <P1 html={sections.tabNineSection.section1.content()} as="p" />
          </FormattedText>
        ),
        goodToKnow: {
          title: sections.tabNineSection.section1.goodToKnow.title(),
          content: sections.tabNineSection.section1.goodToKnow.content(),
        },
      },
      usa: {
        rights: sections.tabNineSection.usa.rights,
        grid: [
          [
            sections.tabNineSection.usa.grid.row1.col1(),
            sections.tabNineSection.usa.grid.row1.col2(),
            sections.tabNineSection.usa.grid.row1.col3(),
          ],
          [
            sections.tabNineSection.usa.grid.row2.col1(),
            sections.tabNineSection.usa.grid.row2.col2(),
            sections.tabNineSection.usa.grid.row2.col3(),
          ],
          [
            sections.tabNineSection.usa.grid.row3.col1(),
            sections.tabNineSection.usa.grid.row3.col2(),
            sections.tabNineSection.usa.grid.row3.col3(),
          ],
          [
            sections.tabNineSection.usa.grid.row4.col1(),
            sections.tabNineSection.usa.grid.row4.col2(),
            sections.tabNineSection.usa.grid.row4.col3(),
          ],
        ],
        students: sections.tabNineSection.usa.students,
      },
      rights: [
        {
          id: SectionContentLinkListIdNine.California,
          titleElement: setTitleElement(SectionContentLinkListIdNine.California),
          content: sections.tabNineSection.rights[0](),
        },
        {
          id: SectionContentLinkListIdNine.Colorado,

          titleElement: setTitleElement(SectionContentLinkListIdNine.Colorado),
          content: sections.tabNineSection.rights[1](),
        },
        {
          id: SectionContentLinkListIdNine.Colorado,
          titleElement: setTitleElement(SectionContentLinkListIdNine.Connecticut),
          content: sections.tabNineSection.rights[2](),
        },
        {
          id: SectionContentLinkListIdNine.NewJersey,
          titleElement: setTitleElement(SectionContentLinkListIdNine.NewJersey),
          content: sections.tabNineSection.rights[3](),
        },
        {
          id: SectionContentLinkListIdNine.Oregon,

          titleElement: setTitleElement(SectionContentLinkListIdNine.Oregon),
          content: sections.tabNineSection.rights[4](),
        },
        {
          id: SectionContentLinkListIdNine.Texas,

          titleElement: setTitleElement(SectionContentLinkListIdNine.Texas),
          content: sections.tabNineSection.rights[5](),
        },
        {
          id: SectionContentLinkListIdNine.Utah,

          titleElement: setTitleElement(SectionContentLinkListIdNine.Utah),
          content: sections.tabNineSection.rights[6](),
        },
        {
          id: SectionContentLinkListIdNine.Virginia,
          titleElement: setTitleElement(SectionContentLinkListIdNine.Virginia),
          content: sections.tabNineSection.rights[7](),
        },
      ],
    },
  };
};
